(() => {
 const groups=[...document.querySelectorAll('.deep-nav__group')];
 const mobile=document.querySelector('.deep-mobile-menu');
 const closeGroups=except=>groups.forEach(group=>{if(group!==except)group.open=false;});
 groups.forEach(group=>{
  group.addEventListener('toggle',()=>{if(group.open)closeGroups(group);});
  group.querySelector('summary').addEventListener('click',()=>closeGroups(group));
 });
 document.addEventListener('click',event=>{
  if(!event.target.closest('.deep-nav'))closeGroups();
  if(mobile?.open&&!event.target.closest('.deep-mobile-menu'))mobile.open=false;
 });
 document.addEventListener('focusin',event=>{
  if(!event.target.closest('.deep-nav'))closeGroups();
  if(mobile?.open&&!event.target.closest('.deep-mobile-menu'))mobile.open=false;
 });
 document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const group=groups.find(group=>group.open);
  if(group){group.open=false;group.querySelector('summary').focus();}
  if(mobile?.open){mobile.open=false;mobile.querySelector('summary').focus();}
 });
 document.querySelectorAll('.deep-nav__panel a,.deep-mobile-menu nav a').forEach(link=>link.addEventListener('click',()=>{closeGroups();if(mobile)mobile.open=false;}));
 const inquiry=document.getElementById('register'),mobileCta=document.querySelector('.mobile-cta');
 if(inquiry&&mobileCta&&typeof IntersectionObserver!=='undefined'){
  const observer=new IntersectionObserver(entries=>{mobileCta.hidden=entries.some(entry=>entry.isIntersecting);});
  observer.observe(inquiry);
 }
// Follow the supplied four-video order in one continuous file, with chapter controls.
(() => {
 const video=document.getElementById('making-video');
 const choices=[...document.querySelectorAll('[data-video]')];
 if(!video||!choices.length)return;
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 const status=document.querySelector('[data-video-status]');
 const starts=choices.map(button=>Number(button.dataset.start));
 let index=-1,pending=0;
 const updateIndex=()=>{
  const next=Math.max(0,starts.findLastIndex(start=>video.currentTime>=start));
  if(next===index)return;
  index=next;choices.forEach((choice,n)=>choice.setAttribute('aria-pressed',String(n===index)));
 };
 const select=(next,play)=>{
  const request=++pending,button=choices[next];
  const seek=()=>{
   if(request!==pending)return;
   video.currentTime=starts[next];updateIndex();
   if(status)status.textContent=button.textContent+' selected.';
   if(play)video.play().catch(()=>{if(status)status.textContent+=' Use the video controls to play.';});
  };
  if(video.readyState>=1)seek();
  else video.addEventListener('loadedmetadata',seek,{once:true});
 };
 choices.forEach((button,n)=>button.addEventListener('click',()=>select(n,!reduce.matches)));
 video.addEventListener('timeupdate',updateIndex);
 video.addEventListener('seeked',updateIndex);
 video.addEventListener('ended',()=>{if(!reduce.matches)select(0,true);});
 const respectMotion=()=>{video.autoplay=!reduce.matches;if(reduce.matches)video.pause();};
 respectMotion();updateIndex();reduce.addEventListener('change',respectMotion);
})();

 document.querySelectorAll('[data-origin-leaf-preview-send]').forEach(button=>{
  button.addEventListener('click',()=>{
    const preview=button.closest('[data-origin-leaf-preview-form]');
    preview.querySelector('[data-preview-response]').textContent=preview.dataset.previewMessage;
  });
  button.disabled = false;
 });
})();

// Keep navigation inside the explicitly selected unpublished theme.
(() => {
 const themeId = document.body.dataset.originLeafPreviewThemeId || document.documentElement.dataset.originLeafPreviewThemeId || new URLSearchParams(location.search).get('preview_theme_id');
 if (!themeId || !/^\d+$/.test(themeId)) return;
 document.querySelectorAll('a[href]').forEach(link => {
  const url = new URL(link.getAttribute('href'), location.href);
  if (url.origin !== location.origin || link.getAttribute('href').startsWith('#')) return;
  url.searchParams.set('preview_theme_id', themeId);
  link.href = url.pathname + url.search + url.hash;
 });
})();
